import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";

const PostMediaList = ({ children, wrap, size }) => {
  const childrenArray = useMemo(
    () => React.Children.toArray(children),
    [children]
  );
  const childrenArrayExtended = useMemo(
    () =>
      React.Children.map(childrenArray, (item, index) => {
        if (React.isValidElement(item)) {
          return React.cloneElement(item, {
            size,
            isFirst: index === 0,
            isLast: index === childrenArray.length - 1,
          });
        }
        return item;
      }),
    [childrenArray, size]
  );

  return (
    <Box margin="-0.5" overflow="hidden" overflowX={wrap ? null : "auto"}>
      <Box display="flex" flexWrap={wrap ? "wrap" : null}>
        {childrenArrayExtended.map((item) => (
          <Box key={item?.key} margin="0.5">
            {item}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

PostMediaList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  wrap: PropTypes.bool,
  size: PropTypes.string,
};

PostMediaList.defaultProps = {
  children: undefined,
  wrap: undefined,
  size: undefined,
};

export default memo(PostMediaList);
